import type { IconSvgObject } from './types';

const LimitOrderIcon: IconSvgObject = [
  ["circle", { cx: "12", cy: "14", r: "3", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M10 11.5L5.5 7H3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M18 13.9998V14.0098M21 13.99V14", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M3 14V14.01M6 14.01V14.02", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M12 13.99V14", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export default LimitOrderIcon;
